module.exports = __webpack_public_path__ + "static/media/velour11A.3663364e.jpg";